import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useConfig } from "../context/ConfigContext";
import { clearStoreItem, logout, } from "../store/actions/actions";
import { clearCart, setCartExpiration } from "../store/cart/cartActions";
import { authAxios, unAuthAxios } from "./apiGate";

const AxiosInterceptor = () => {
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const { config } = useConfig();


  useEffect(() => {

    const logoutUser = () => {
      window.location.replace("/");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("token");

      dispatch(clearStoreItem("auth3dthird"));
      dispatch(clearStoreItem("authGoogleSuccess"));
      dispatch(clearStoreItem("authAppleSuccess"));
      dispatch(clearCart());
      dispatch(logout());

    };

    const responseInterceptor = authAxios.interceptors.response.use(
      (response) => response,
      (error) => {
        console.error("Axios Error:", error);
        if (error.response?.status === 401 || error.message === 'Network Error') {
          logoutUser();
        }
        return Promise.reject(error);
      }
    );

    const unauthResponseInterceptor = unAuthAxios.interceptors.response.use(
      (response) => response,
      (error) => {
        console.error("Axios Error:", error);
        if (error.response?.status === 401 || error.message === 'Network Error') {
          logoutUser();
        }
        return Promise.reject(error);
      }
    );

    return () => {
      authAxios.interceptors.response.eject(responseInterceptor);
      unAuthAxios.interceptors.response.eject(unauthResponseInterceptor);
    };
  }, [dispatch]);

  useEffect(() => {
    if (config?.cart_expiration_minutes) {

      dispatch(setCartExpiration(config?.cart_expiration_minutes))
    }
  }, [dispatch, config]);

  return null;
};

export default AxiosInterceptor;
